import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericService } from './generic.service';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { environment } from '../../environments/environment';
import { CompanyModel } from '../models/company.model';

@Injectable({
	providedIn: 'root',
})
export class CompaniesService extends GenericService<CompanyModel> {
	company$ = new BehaviorSubject<CompanyModel | null>(null);

	company: CompanyModel | null = null;
	addPopup$ = new BehaviorSubject<boolean>(false);
	companiesChange$ = new BehaviorSubject<boolean>(false);

	constructor() {
		super();
		this.endpoint = 'companies';
		this.ACTIONS = {
			list: 'COMPANY_LIST',
			add: 'COMPANY_ADD',
			update: 'COMPANY_UPDATE',
			delete: 'COMPANY_DELETE',
			item: 'COMPANY_ITEM',
		};
	}

	setActiveCompany(company: CompanyModel) {
		localStorage.setItem(`${environment.project}_active_company`, JSON.stringify(company));
		this.company = new CompanyModel(company);
		this.company$.next(this.company);
	}

	async getActiveCompany() {
		const inst = await localStorage.getItem(`${environment.project}_active_company`);
		if (inst) {
			this.companiesChange$.next(false);
			this.company = new CompanyModel(JSON.parse(inst));
			this.company$.next(this.company);
			this.companiesChange$.next(true);
		}
	}

	async firstChangeActiveCompany() {
		const inst = await localStorage.getItem(`${environment.project}_active_company`);
		if (inst) {
			this.company = new CompanyModel(JSON.parse(inst));
			this.company$.next(this.company);
		}
		this.companiesChange$.next(true);
	}

	getCompanyAdmin(userId?: string): any {
		if (!userId) {
			return this.company?.getOwners();
		}
		return !!this.company?.getOwners().find((x) => x.userId === userId);
	}

	clearCompany() {
		localStorage.removeItem(`${environment.project}_active_company`);
		this.company$.next(null);
	}

	createCompany(company: CompanyModel) {
		return super.add(company);
	}

	getCompany(uuid: string) {
		return super.get(uuid);
	}

	findAllCompanies(params: any) {
		return super.list(params);
	}

	updateCompany(uuid: string, company: CompanyModel) {
		return super.update(uuid, company);
	}
}
